<p-toast></p-toast>

<div class="bs-page" [class.bs-page--reports]="activeTab === 'reports'">
  <div class="bs-header">
    <h1 class="bs-title">Block Schedule</h1>
    <div class="switch-tabs">
      <button type="button" [class.active]="activeTab === 'reports'" (click)="setTab('reports')">Reports</button>
      <button type="button" [class.active]="activeTab === 'inverterModel'" (click)="setTab('inverterModel')">Inverter Model</button>
      <button type="button" [class.active]="activeTab === 'incoTerms'" (click)="setTab('incoTerms')">Inco Terms</button>
      <button type="button" [class.active]="activeTab === 'projectStatus'" (click)="setTab('projectStatus')">Project Status</button>
      <button type="button" [class.active]="activeTab === 'integrator'" (click)="setTab('integrator')">Integrator</button>
      <button type="button" [class.active]="activeTab === 'transformer'" (click)="setTab('transformer')">Transformer</button>
    </div>
  </div>

  @if (activeTab === 'reports') {
    <div class="bs-reports-wrap">
      <app-blockschedule-report />
    </div>
  }

  @if (activeTab !== 'reports') {
  <div class="bs-grid-wrap">
    <div class="bs-panel-hdr">
      <p class="bs-panel-desc">Manage block schedule reference data used across projects.</p>
      <button class="bs-btn-add" type="button" (click)="openAddDialog()" [disabled]="loading">
        <i class="ri-add-line"></i>
        Add New
      </button>
    </div>

    <div class="bs-grid-header" [class.bs-has-desc]="hasDescription">
      <div>ID</div>
      <div>Name</div>
      @if (hasDescription) {
        <div>Description</div>
      }
      <div>Action</div>
    </div>

    <div class="bs-grid-body">
      @if (loading) {
        <div class="bs-empty"><i class="ri-loader-4-line ctrl-spin"></i> Loading...</div>
      } @else if (currentList.length === 0) {
        <div class="bs-empty">No records found.</div>
      } @else {
        @for (item of currentList; track $index) {
          <div class="bs-grid-row" [class.bs-has-desc]="hasDescription">
            <div>{{ getItemId(item) }}</div>
            <div>{{ item.name }}</div>
            @if (hasDescription) {
              <div>{{ item.description || '—' }}</div>
            }
            <div class="bs-action-cell">
              <button
                type="button"
                class="bs-icon-btn"
                (click)="openEditDialog(item)"
                [disabled]="deleting"
                title="Edit">
                <i class="ri-pencil-line"></i>
              </button>
              <button
                type="button"
                class="bs-icon-btn bs-icon-btn--delete"
                (click)="confirmDelete(item)"
                [disabled]="deleting"
                title="Delete">
                <i class="ri-delete-bin-line"></i>
              </button>
            </div>
          </div>
        }
      }
    </div>
  </div>
  } <!-- end @if activeTab !== 'reports' -->

</div>

<!-- Add / Edit Dialog -->
<p-dialog
  [header]="dialogTitle"
  [(visible)]="showFormDialog"
  [modal]="true"
  [style]="{ width: '32rem' }"
  styleClass="kansei-dialog"
  [contentStyle]="{ overflow: 'visible' }">
  <div class="modal-form-body">
    <div class="bs-form-field">
      <label class="modal-label">Name <span class="req">*</span></label>
      <input
        type="text"
        class="bs-input"
        [(ngModel)]="formName"
        placeholder="Enter name"
        [disabled]="saving" />
    </div>
    @if (hasDescription) {
      <div class="bs-form-field">
        <label class="modal-label">Description</label>
        <input
          type="text"
          class="bs-input"
          [(ngModel)]="formDescription"
          placeholder="Enter description"
          [disabled]="saving" />
      </div>
    }
  </div>
  <ng-template pTemplate="footer">
    <div class="modal-footer">
      <button type="button" class="modal-btn-cancel" (click)="showFormDialog = false" [disabled]="saving">Cancel</button>
      <button type="button" class="modal-btn-primary" (click)="saveForm()" [disabled]="saving">
        @if (saving) { <i class="ri-loader-4-line ctrl-spin"></i> }
        Save
      </button>
    </div>
  </ng-template>
</p-dialog>

<!-- Delete Confirmation Dialog -->
<p-dialog
  header="Confirm Delete"
  [(visible)]="showDeleteDialog"
  [modal]="true"
  [style]="{ width: '28rem' }"
  styleClass="kansei-dialog"
  [contentStyle]="{ overflow: 'visible' }">
  <div class="modal-form-body">
    <p class="bs-delete-msg">Are you sure you want to delete <strong>{{ deleteTargetName }}</strong>? This action cannot be undone.</p>
  </div>
  <ng-template pTemplate="footer">
    <div class="modal-footer">
      <button type="button" class="modal-btn-cancel" (click)="showDeleteDialog = false" [disabled]="deleting">Cancel</button>
      <button type="button" class="bs-btn-delete" (click)="executeDelete()" [disabled]="deleting">
        @if (deleting) { <i class="ri-loader-4-line ctrl-spin"></i> }
        Delete
      </button>
    </div>
  </ng-template>
</p-dialog>
